/* 
Author:Lamiaa Moustafa
Desc: All inputs styles js
*/

import styled from "styled-components";

// Login Form Style
export const Form = styled.form`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

// Main Input Style for login, forgot password
export const Input = styled.input`
  width: ${(props) => (props.width ? "50%" : "200px")};
  padding: 20px;
  margin: 5px 40px;
  max-height: 50px;
  background-color: var(--white);
  opacity: 0.7;
  z-index: 99;
  border-color: var(--lightGray);
  ::placeholder {
    font-weight: var(--regularFont);
    color: var(--black);
    font-family: var(--fontFamily);
    font-size: 18px;
  }
  :focus {
    outline: none;
    border-color: var(--orange);
  }
  @media (max-width: 768px) {
    width: 80%;
    margin: 10px 15px;
  }
`;

// customStyle for adjusting bottom spacing
// export const InputMargin = {
//   marginBottom: "4em",
// };

// customStyle for adjusting bottom spacing
export const EmailInput = {
  marginBottom: "1em",
};
